import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'magic_nav',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    showShadow: function showShadow() {
      var _this$value, _this$value$config;
      var magicType = (_this$value = this.value) === null || _this$value === void 0 ? void 0 : (_this$value$config = _this$value.config) === null || _this$value$config === void 0 ? void 0 : _this$value$config.magic_type;
      // 样式1始终展示阴影
      if (magicType === '1') return true;
      // 样式6/7根据is_show_shadow控制，默认展示阴影
      if (['6', '7'].includes(magicType)) {
        var _this$value2, _this$value2$config;
        return ((_this$value2 = this.value) === null || _this$value2 === void 0 ? void 0 : (_this$value2$config = _this$value2.config) === null || _this$value2$config === void 0 ? void 0 : _this$value2$config.is_show_shadow) !== 0;
      }
      return false;
    }
  }
};